module.exports = __webpack_public_path__ + "img/selected2-min.bb1c0f19.png";